/**
 * conference slice: 회의 모드, 상태 관리
 * wehago-conference의 redux/modules/conference 에서 리팩토링
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ConferenceMode, ConferenceStatus } from '@/types/store';

// re-export for backwards compatibility
export type { ConferenceMode, ConferenceStatus } from '@/types/store';

export interface ConferenceState {
  status: ConferenceStatus;
  mode: ConferenceMode;
  maxParticipants: number;
  maxActiveCameras: number;

  // 회의 메타데이터
  roomType: string;    // 일반 회의, 1:1 상담 등
  startTime: number | null;
  endTime: number | null;

  // 에러
  errorCode: string | null;
  errorMessage: string | null;

  // 기능 flags
  isLocked: boolean;
  isRecording: boolean;
  isLiveStreaming: boolean;

  // 역할
  myRole: string;
  isModerator: boolean;
}

const initialState: ConferenceState = {
  status: 'idle',
  mode: 'group',
  maxParticipants: 50,
  maxActiveCameras: 2,

  roomType: '',
  startTime: null,
  endTime: null,

  errorCode: null,
  errorMessage: null,

  isLocked: false,
  isRecording: false,
  isLiveStreaming: false,

  myRole: 'none',
  isModerator: false,
};

const conferenceSlice = createSlice({
  name: 'conference',
  initialState,
  reducers: {
    setStatus(state, action: PayloadAction<ConferenceStatus>) {
      state.status = action.payload;
      if (action.payload === 'joined') {
        state.startTime = state.startTime ?? Date.now();
        state.errorCode = null;
        state.errorMessage = null;
      }
    },

    setMode(state, action: PayloadAction<ConferenceMode>) {
      state.mode = action.payload;
    },

    setRoomType(state, action: PayloadAction<string>) {
      state.roomType = action.payload;
    },

    setError(state, action: PayloadAction<{ code: string; message: string } | null>) {
      if (action.payload) {
        state.errorCode = action.payload.code;
        state.errorMessage = action.payload.message;
        state.status = 'failed';
      } else {
        state.errorCode = null;
        state.errorMessage = null;
      }
    },

    setLocked(state, action: PayloadAction<boolean>) {
      state.isLocked = action.payload;
    },

    setRecording(state, action: PayloadAction<boolean>) {
      state.isRecording = action.payload;
    },

    setRole(state, action: PayloadAction<{ role: string; isModerator: boolean }>) {
      state.myRole = action.payload.role;
      state.isModerator = action.payload.isModerator;
    },

    reset() {
      return initialState;
    },
  },
});

export const conferenceActions = conferenceSlice.actions;
export default conferenceSlice.reducer;
